<template>
    <v-row class="ma-0">
        <view-user :user-id="selectedContactId"
                    v-model="showViewContactDialog"
                    @clearUserIdAndAuths="selectedContactId = ''"
                    @getUsers="getContacts()"/>
        <DeleteContact :contact="selectedContactForDelete"
                       @clearContact="selectedContactForDelete=$event"
                       v-model="showDeleteContactDialog">
        </DeleteContact>

        <v-col cols="12" class="pb-0">
            <v-card-text>
                <v-row align="center">
                    <v-col cols="12" sm="6">
                        <h3 class="kbDarkBlueText--text">
                          {{ $t('general.contacts') }}
                        </h3>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field :placeholder="$t('general.search')"
                                      color="kbDarkBlueText"
                                      append-icon="search"
                                      @click:append="getContacts()"
                                      clearable>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-col>
        <v-col cols="12" class="pt-0">
            <v-data-table :must-sort="false"
                          :headers="headers"
                          :items="contacts"
                          class="elevation-2"
                          :loading="loading"
                          :footer-props="{
                            'items-per-page-text': `${$t('general.contacts')} ${$t('general.perPage')}`,
                            'items-per-page-options': [50, 100, 200]
                          }">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>
                            {{item.name}}
                        </td>

                        <td>
                            {{item.email || $t('general.noEmail')}}
                        </td>

                        <td>
                            {{item.phone || $t('general.noPhone')}}
                        </td>

                        <td>
                            <span v-if="item.roles.length === 0">
                                {{ $t('general.noRoles') }}
                            </span>

                            <span v-else>
                                {{item.roles.join(', ')}}
                            </span>
                        </td>

                        <td class="d-flex align-center justify-center" style="height: inherit">
                            <v-btn icon text @click="showViewContact(item)" color="kbDarkBlueText">
                                <v-icon>remove_red_eye</v-icon>
                            </v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="deleteContact(item.userId)"
                                           color="kbRed"
                                           icon
                                           v-on="on">
                                        <v-icon>
                                            delete
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('general.deleteContact') }}</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" cols="12" v-if="loading">
                            {{ $t('general.loadingBusinessContacts', { business: businessModule.s }) }}
                        </v-col>
                        <v-col cols="12" class="red--text text-center" v-else>
                            {{ $t('general.noBusinessContacts', { business: businessModule.s }) }}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import DeleteContact from '@/pages/App/Businesses/dialogs/DeleteContact'
import ViewUser from '@/pages/App/People/dialogs/ViewUser/ViewUser'
import { EventBus } from '../../../eventBus.js'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    DeleteContact,
    ViewUser
  },
  computed: {
    ...mapState({
      language: state => state.auth.language
    }),
    ...mapGetters(['businessModule'])
  },
  created () {
    this.getContacts()
    EventBus.$on('getBusinessContacts', () => this.getContacts())
  },
  data () {
    return {
      contacts: [],
      headers: [
        { text: this.$t('general.name'), align: 'left', sortable: false },
        { text: this.$t('general.emailOrPhone'), align: 'left', sortable: false },
        { text: this.$t('general.phone'), align: 'left', sortable: false },
        { text: this.$t('general.position'), align: 'left', sortable: false },
        { text: this.$t('general.actions'), align: 'center', sortable: false }
      ],
      loading: false,
      selectedContactForDelete: '',
      showDeleteContactDialog: false,
      selectedContactId: '',
      showViewContactDialog: false
    }
  },
  methods: {
    deleteContact (contact) {
      this.selectedContactForDelete = contact
      this.showDeleteContactDialog = true
    },
    async showViewContact (contact) {
      this.selectedContactId = contact.UUID
      this.showViewContactDialog = true
    },
    async getContacts () {
      try {
        this.loading = true
        this.contacts = await this.$store.dispatch('getContacts', this.$route.params.businessid)
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    }
  },
  watch: {
    language () {
      this.headers[0].text = this.$t('general.name')
      this.headers[1].text = this.$t('general.emailOrPhone')
      this.headers[2].text = this.$t('general.phone')
      this.headers[3].text = this.$t('general.position')
      this.headers[4].text = this.$t('general.actions')
    }
  }
}
</script>
